var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0087 8.64987L8.4156 6.05674L11.0368 3.43555C11.6982 2.77413 11.699 1.697 11.0384 1.03649C10.3779 0.375976 9.3008 0.376716 8.63938 1.03814L6.04268 3.63483L3.4251 1.01724C2.76458 0.35673 1.68745 0.35747 1.02603 1.01889C0.364608 1.68031 0.363867 2.75745 1.02438 3.41796L3.6175 6.01108L1.02081 8.60777C0.35939 9.2692 0.358649 10.3463 1.01916 11.0068C1.67967 11.6674 2.75681 11.6666 3.41823 11.0052L5.99042 8.433L8.58355 11.0261C9.24406 11.6866 10.3212 11.6859 10.9826 11.0245C11.644 10.363 11.6692 9.31038 11.0087 8.64987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.182dad6a0a346a5009a4ab077fb6bc9a.svg";
export { ForwardRef as ReactComponent };